$( document ).ready(function(evt) {
  var checkboxes = $('.product-type');
  checkboxes.change(function() {
    var checked = checkboxes.filter(':checked');
    var limit= checked.attr('maxlength');
    console.log(limit);
    if (checked.length > limit) {
      this.checked = false;
    }
  });


  $('.product-select').click(function(){
      if($(this).is(":checked")){
        var get_ld=$('.product-data').attr('data-id');
       var abc= $(".product__add-button").attr("data_id", get_ld);
        console.log(abc);
         var def=  $(".product__add-button").attr("data-attr", get_ld);
        console.log(def);

 
      }
      else if($(this).is(":not(:checked)")){
    $(".product__add-button").attr("data_id", "");  
      }
    });
 $(".product-select:checked").prop("checked", false).removeAttr("checked");
 
    $(".product__add-button").on("click",function(e){
    e.preventDefault();
    // var get_id= $(this).attr("variant-id");
    //   console.log(get_id);
    var data_id =$(this).attr("data_id");
      console.log(data_id);
     // var totalVariant = [ data_id];
     
  
    if(data_id!='')
    {
 $.ajax({
            type:"post",
            dataType: "json",
            url: '/cart/add.js',
            data:{id:data_id, quantity:1},
            async:false,
            success: function(data)
            {
              console.log("Success");
            }
          });
    } 
  });

});

$( window ).on("load", function() {
    $("button.Sd_addProduct.add_to_cart.button.med-btn.product__add-button").removeAttr("disabled");
});